import { TransferListingProperties } from "../../types/transferListing.type";
import { Button, Card, Table, Tag } from "antd";
import CustomPagination from "../../components/CustomPagination";
import { ColumnsType } from "antd/lib/table";
import { Link, useHistory } from "react-router-dom";
import NotSet from "../../components/NotSet";
import { formatYearToTime } from "../../helpers/format";
import { renderRoles } from "../../helpers/renderRoles";
import { CLIENT_CMS, CLIENT_MOBILE } from "../employee/constant";

interface IProps {
	isLoading: boolean;
	data: TransferListingProperties[];
	pagination: any;
	changePage: any;
}
export default function History(props: IProps) {
	const history = useHistory();
	const COLUMNS: ColumnsType<TransferListingProperties> = [
		{
			title: "FROM AGENT ID",
			dataIndex: ["originListingEmployee", "employeeCode"],
			key: "employeeCode",
			width: 150,
			render: (employeeCode: string, record: TransferListingProperties) => {
				return <Link to={`/agent/${record.originListingUserId}`}>{employeeCode?.toUpperCase()}</Link>;
			},
		},
		{
			title: "FROM AGENT NAME",
			dataIndex: ["originListingUser", "nickName"],
			key: "nickName",
			width: 200,
			render: (nickname: string) => <>{nickname ? nickname.toUpperCase() : <NotSet />}</>,
		},
		{
			title: "OFFICE",
			dataIndex: ["originListingOffice", "officeName"],
			key: "officeName",
			width: 200,
			render: (officeName: string) => <>{officeName ? officeName.toUpperCase() : <NotSet />}</>,
		},
		{
			title: "TRANSFERRED LISTING",
			dataIndex: "listingTransferHistoryCount",
			key: "listingTransferHistoryCount",
			width: 80,
			render(_, record: TransferListingProperties) {
				return (record?.metadata?.transferListingData ?? [])?.length + " Listing";
			},
		},
		{
			title: "TRANSFERRED AT",
			dataIndex: "createdAt",
			key: "createdAt",
			width: 150,
			render(value) {
				return formatYearToTime(value);
			},
		},
		{
			title: "ACTION BY",
			dataIndex: ["createdByUserMeta", "name"],
			key: "name",
			width: 150,
			render: (name: string, record: TransferListingProperties) => (
				<>
					{name ?? "SYSTEM"} (Roles:{" "}
					{record?.createdByUserMeta?.actionRoleUser ? (
						renderRoles(record.createdByUserMeta?.actionRoleUser.split(","))
					) : (
						<NotSet />
					)}
					)
				</>
			),
		},
		{
			title: "PLATFORM",
			dataIndex: "clientId",
			key: "clientId",
			width: 120,
			render: (clientId: string) =>
				clientId === CLIENT_CMS ? (
					<Tag color="blue">CMS</Tag>
				) : clientId === CLIENT_MOBILE ? (
					<Tag color="green">MOBILE</Tag>
				) : (
					<NotSet />
				),
		},
		{
			title: "VERSION",
			dataIndex: "clientVersion",
			key: "clientVersion",
			width: 120,
			render: (clientVersion: string, record: TransferListingProperties) =>
				record.clientId === CLIENT_CMS ? (
					<Tag color="blue">{clientVersion}</Tag>
				) : record.clientId === CLIENT_MOBILE ? (
					<Tag color="green">{clientVersion}</Tag>
				) : (
					<NotSet />
				),
		},
		{
			title: "",
			dataIndex: "transferListingId",
			key: "action",
			width: 150,
			render: (transferListingId: string) => {
				return (
					<Button
						type="primary"
						onClick={() => {
							history.push(`/transfer-listing/${transferListingId}/detail`);
						}}
					>
						View Detail
					</Button>
				);
			},
		},
	];

	return (
		<div>
			<Card
				bordered={false}
				size="small"
			>
				<Table
					loading={props.isLoading}
					columns={COLUMNS}
					dataSource={props.data}
					pagination={false}
					rowKey="transferListingId"
					scroll={{ x: "100%" }}
				/>
				<CustomPagination
					current={props.pagination.page}
					total={props.pagination.totalData}
					defaultPageSize={props.pagination.perPage}
					pageSize={props.pagination.perPage}
					onChange={props.changePage}
				/>
			</Card>
		</div>
	);
}
